import { StoreState, useAppDispatch } from 'store';
import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { sidebarActions } from 'features/sidebar/redux/sidebar.action';
import useRoot from 'hooks/use-root';

export default function useSidebar() {
  const dispatch = useAppDispatch();
  const sidebarState = useSelector((state: StoreState) => state.sidebar);
  const { defaultPage } = useRoot();

  const displayBurger = useMemo(() => {
    const sidebarMenuItems = sidebarState.listSidebarMenuItems;

    if (!sidebarMenuItems?.length) return false;

    if (
      sidebarMenuItems.length === 1 &&
      sidebarMenuItems[0].link === defaultPage
    )
      return false;

    return true;
  }, [defaultPage, sidebarState.listSidebarMenuItems]);

  const getSidebarMenuItems = useCallback(() => {
    dispatch(sidebarActions.getSidebarMenuItemsRequest());
  }, [dispatch]);

  return { sidebarState, getSidebarMenuItems, displayBurger };
}
